import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import cameraService from './cameraService';

const CameraCapture = ({setCustomerImageFile}) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [image, setImage] = useState(null);
  const [imagefile, setImageFile] = useState(null);
  const location = useLocation();

 
  
  

  useEffect(() => {
    if (videoRef.current) {
      cameraService.setVideoElement(videoRef.current);
      cameraService.startCamera();
    }

    return () => {
      cameraService.stopCamera();
    };
  }, []);

  useEffect(() => {
    if (location.pathname !== '/newcustomer/add-new-customer') {
      cameraService.stopCamera();
    }
  }, [location.pathname]);

  // const capturePhoto = () => {
  //   const canvas = canvasRef.current;
  //   const video = videoRef.current;

  //   if (video && canvas) {
  //     canvas.width = video.videoWidth;
  //     canvas.height = video.videoHeight;

  //     const ctx = canvas.getContext('2d');
  //     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

  //     const imageData = canvas.toDataURL('image/png');
  //     setImage(imageData);

  //     cameraService.stopCamera();
  //   }
  // };

  const capturePhoto = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
  
    if (video && canvas) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
  
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  
      const dataUrl = canvas.toDataURL('image/png');
  
      // Convert base64 to Blob
      const byteString = atob(dataUrl.split(',')[1]);
      const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];
  
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
  
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
  
      const blob = new Blob([ia], { type: mimeString });
  
      // If you need it as a File object for uploads
      const file = new File([blob], 'captured-image.png', { type: mimeString });
  
      // Now you can upload it using FormData, for example:
      // const formData = new FormData();
      // formData.append('image', file);
  
      // If you need to preview or use the object URL:
      const objectUrl = URL.createObjectURL(file);
      setImage(objectUrl); // Optional: preview
  
      // Optionally keep a reference to the File object
      setImageFile(file);
      setCustomerImageFile(file); // <-- You can add this state to store the File
  
      cameraService.stopCamera();
    }
  };
  

  const retakePhoto = () => {
    setImage(null);
    cameraService.startCamera();
  };


  return (
    <div>
    
      <video
        ref={videoRef}
        style={{ width: '100%', maxWidth: '500px', display:image!=null?'none':'block'}}
        autoPlay
        playsInline
        muted
      />
     
      {image && (
        <img
          src={image}
          alt="Captured"
          style={{ width: '100%', maxWidth: '500px', marginTop: '10px' }}
        />
      )}
      <canvas ref={canvasRef} style={{ display: 'none' }} /> 
      <div style={{ marginTop: '10px' }}>
        {image ? (
          <button onClick={retakePhoto}>🔄 Retake</button>
        ) : (
           
          <button onClick={capturePhoto}>📸 Capture</button>
        
        )}
      </div>

    </div>
  );
};

export default CameraCapture;






